import React from 'react';
import { Bot, Phone, Mail } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

export const AIAvatar = ({ d, className = 'w-7 h-7', icon = 'w-4 h-4' }) => (
  d?.avatar_url
    ? <img src={d.avatar_url} alt="" className={`${className} rounded-full object-cover shrink-0 bg-white`} data-testid="ai-avatar-img" />
    : <span className={`${className} rounded-full text-white flex items-center justify-center shrink-0`} style={{ background: d?.accent_color || '#0c4a6e' }}><Bot className={icon} /></span>
);

const WaIcon = () => (
  <svg viewBox="0 0 32 32" className="w-3 h-3" fill="currentColor" aria-hidden="true"><path d="M16.05 5.33c-5.86 0-10.62 4.76-10.63 10.61 0 1.87.49 3.69 1.42 5.3l-1.51 5.51 5.65-1.48a10.6 10.6 0 005.07 1.29c5.86 0 10.62-4.76 10.63-10.61A10.6 10.6 0 0016.05 5.33z" /></svg>
);

export const useChatContacts = (d) => {
  const { settings } = useSettings();
  const c = settings?.contact || {};
  return {
    phone: d?.contact_phone || c.phone || '',
    whatsapp: (d?.contact_whatsapp || c.whatsapp_number || '').replace(/\D/g, ''),
    email: d?.contact_email || c.email || '',
  };
};

export const ChatContacts = ({ d }) => {
  const k = useChatContacts(d);
  if (d?.show_contacts === false || !(k.phone || k.whatsapp || k.email)) return null;
  const cls = 'inline-flex items-center gap-1 rounded-full border border-neutral-200 bg-white px-2 py-0.5 text-[10px] font-semibold text-neutral-700 hover:bg-neutral-50';
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5 px-1" data-testid="ai-chat-contacts">
      {k.phone && <a href={`tel:${k.phone.replace(/\s/g, '')}`} className={cls} data-testid="ai-contact-phone"><Phone className="w-3 h-3" />Anrufen</a>}
      {k.whatsapp && <a href={`https://wa.me/${k.whatsapp}`} target="_blank" rel="noopener noreferrer" className={cls} data-testid="ai-contact-whatsapp"><WaIcon />WhatsApp</a>}
      {k.email && <a href={`mailto:${k.email}`} className={cls} data-testid="ai-contact-email"><Mail className="w-3 h-3" />E-Mail</a>}
    </div>
  );
};
